'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmailCMF = undefined;

var _contentTypes = require('../constants/contentTypes');

var _isCommonMessageFormat = require('./isCommonMessageFormat');

var _commonMessageFormatGetters = require('./commonMessageFormatGetters');

var isEmailCMF = exports.isEmailCMF = function isEmailCMF(message) {
  return (0, _isCommonMessageFormat.isCommonMessageFormat)(message) && (0, _commonMessageFormatGetters.getContentType)(message) === _contentTypes.EMAIL;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/operators/isEmailCMF.js
// module id = 702
// module chunks = 2 3